import { List, useTable } from "@refinedev/antd";
import { Table, Space, Button, Tag, Typography } from "antd";
import { GlassCard } from "../../shared/components";
import { EditOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslate, useGo } from "@refinedev/core";
import { DateField } from "@refinedev/antd";
import { useState } from "react";
import { ClientCreateModal } from "./ClientCreateModal";
import { ClientEditModal } from "./ClientEditModal";

export const ClientList = () => {
  const { tableProps, tableQueryResult } = useTable({
    resource: "clients",
    syncWithLocation: true,
  });

  const _t = useTranslate();
  const go = useGo();

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingClientId, setEditingClientId] = useState<string | null>(null);

  const { Text } = Typography;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <List
        headerButtons={() => [
          <Button
            key="create"
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setCreateModalOpen(true)}
          >
            {_t("clients.titles.create")}
          </Button>,
        ]}
      >
        <style>{`
          .clients-list-table-view .ant-table { background: transparent !important; }
          .clients-list-table-view .ant-table-thead > tr > th { background: transparent !important; }
          .clients-list-table-view .ant-table-tbody > tr > td { background: transparent !important; }
        `}</style>
        <GlassCard className="clients-list-table-view !p-0 overflow-hidden">
          <Table {...tableProps} rowKey="clientId">
            <Table.Column
              dataIndex="name"
              title={_t("clients.fields.name")}
              render={(value: string, record: any) => (
                <Space direction="vertical" size={0}>
                  <Text strong>{value}</Text>
                  <Text type="secondary" className="!text-xs">
                    {record.clientId}
                  </Text>
                </Space>
              )}
            />
            <Table.Column
              dataIndex="scopes"
              title={_t("clients.fields.scopes")}
              render={(scopes: string[]) =>
                Array.isArray(scopes) ? (
                  <Space size={[0, 4]} wrap>
                    {scopes.map((s) => (
                      <Tag key={s} color="blue">
                        {s}
                      </Tag>
                    ))}
                  </Space>
                ) : null
              }
            />
            <Table.Column
              dataIndex="isActive"
              title={_t("clients.fields.isActive")}
              render={(value: boolean) => (
                <Tag color={value ? "green" : "red"}>
                  {value ? _t("titles.yes") : _t("titles.no")}
                </Tag>
              )}
            />
            <Table.Column
              dataIndex="createdAt"
              title={_t("clients.fields.createdAt")}
              render={(value: string) => (
                <DateField value={value} format="DD/MM/YYYY HH:mm" />
              )}
            />
            <Table.Column
              title={_t("table.actions")}
              dataIndex="actions"
              render={(_, record: any) => (
                <Space>
                  <Button
                    icon={<EyeOutlined />}
                    onClick={() =>
                      go({ to: `/clients/show/${record.clientId}` })
                    }
                  />
                  <Button
                    icon={<EditOutlined />}
                    onClick={() => {
                      setEditingClientId(record.clientId);
                      setEditModalOpen(true);
                    }}
                  />
                </Space>
              )}
            />
          </Table>
        </GlassCard>
        <ClientCreateModal
          open={createModalOpen}
          onCancel={() => setCreateModalOpen(false)}
          onSuccess={() => tableQueryResult?.refetch()}
        />
        <ClientEditModal
          open={editModalOpen}
          clientId={editingClientId}
          onCancel={() => {
            setEditModalOpen(false);
            setEditingClientId(null);
          }}
          onSuccess={() => tableQueryResult?.refetch()}
        />
      </List>
    </div>
  );
};
